import React, { useEffect, useState } from 'react'
import { Box, Button, Flex, Heading, Text, Link as ExternalLink } from 'rebass/styled-components'
import { Link } from 'gatsby'
import { onSnapshot, collection, where, query, orderBy, limit } from 'firebase/firestore'
import { db } from '../system/firebase/index'
import AnimationWrapper from '../helpers/Animations'
import SwiperFilmStrip from '../components/swiper/FilmStrip'
import MediaRender from '../components/general/MediaRender'

const GalleryVideo = ({ options }) => {
    const [data, setData] = useState(false)
    const [video, updateVideo] = useState(false)

    useEffect(() => {
        let isCancelled = false

        if (data && data.docs && data.docs.length) {
            switchVideo(data.docs[0])
        }

        if (!data) {
            const sortedData = { collection: 'posts', docs: []}
            const q = query(collection(db, 'posts'), where('categories', 'array-contains-any', ['films']), orderBy('date_published', 'desc'), limit(8))
            onSnapshot(q, (snapshot) => {
                if (!isCancelled) {
                    const items = []
                    snapshot.forEach((doc) => {
                        sortedData.docs.push(doc.data())
                        items.push(sortedData)
                    })
                    setData(sortedData)
                }
            })
        }

        return () => {
            isCancelled = true;
        }
    }, [data])

    const switchVideo = (data) => {
        // Switch the video in the main video display port.
        const strippedString = data.content.description ? data.content.description.replace(/(<([^>]+)>)/gi, '') : data.content.excerpt;
        const load = {
            alt: data.title,
            content: strippedString,
            headline: data.title,
            video: data.content.modules.length ? data.content.modules[0].media.set[0] : data.media.gallery.videos[0],
            coverImage: data.media.set[0],
        }
        updateVideo(load)
    }

    return (
        <>
            {(video) && (
                <Flex
                    bg="charcoal"
                    color="white"
                    flexDirection={['column', 'column', 'column', 'column', 'row']}
                    sx={{
                        position: 'relative',
                        overflow: 'hidden',
                    }}
                >
                    <Box
                        pb={['xxs', 'xxs', 'xxs', 'xxs', 'md']}
                        px={['sm', 'sm', 'sm', 'sm', 'md']}
                        pt="lg"
                        width={['100%', '100%', '100%', '100%', 'calc(100% - 200px)', 'calc(100% - 300px)', 'calc(100% - 492px)']}
                    >
                        {/* Films Gallery header */}
                        <Flex
                            alignContent="flex-start"
                            alignItems="flex-start"
                        >
                            <Box
                                flexGrow="1"
                                pr="md"
                            >
                                <AnimationWrapper type="fade-left">
                                    <Heading
                                        as="h2"
                                        color="aquaDark"
                                        variant="h1"
                                        sx={{
                                            '@media screen and (max-width: 768px)': {
                                                color: 'white',
                                            },
                                        }}
                                    >Films</Heading>
                                </AnimationWrapper>
                            </Box>
                            <Box
                                alignSelf="center"
                                sx={{
                                    '@media screen and (max-width: 768px)': {
                                        display: 'none',
                                    },
                                }}
                            >
                                <Flex
                                    alignContent="flex-end"
                                    alignItems="flex-start"
                                    justifyContent="flex-end"
                                >
                                    <Box
                                        flexGrow="1"
                                        pr="xxs"
                                    >
                                        <Link to="/films/"><Button variant="primary_black">All Films</Button></Link>
                                    </Box>
                                    <Box
                                        flexGrow="1"
                                        pl="xxs"
                                    >
                                        <ExternalLink href="https://www.youtube.com/channel/UCiuFwH2KXoX0iT1Va98AVxQ" target="_blank"><Button variant="primary_black_alt">Kidston on YouTube</Button></ExternalLink>
                                    </Box>
                                </Flex>
                            </Box>
                        </Flex>
                        {/* Media item, its title and description */}
                        <Box
                            pt="lg"
                        >
                            <MediaRender file={video.video} options={{ coverImage: video.coverImage }} />

                            <Box maxWidth='768px' sx={{
                                '@media screen and (max-width: 768px)': {
                                    maxWidth: 'none',
                                },
                            }}>
                                <Heading
                                    as="h2"
                                    variant="h1"
                                    fontSize="24px"
                                    lineHeight="30px"
                                    pt="md" sx={{ textTransform: 'uppercase' }}>{video.headline}</Heading>
                                <Text as="p" variant="paragraph">{video.content}</Text>
                            </Box>
                        </Box>
                        <Box pt="lg" pb="md" sx={{
                            display: 'none',
                            '@media screen and (max-width: 768px)': {
                                display: 'block',
                            },
                        }}>
                            <Box>
                                <Link to="/films/">
                                    <Button
                                        variant="primary_black"
                                        sx={{
                                            width: '100%',
                                        }}
                                    >All films</Button>
                                </Link>
                            </Box>
                            <Box
                                pt="sm"
                            >
                                <ExternalLink href="https://www.youtube.com/channel/UCiuFwH2KXoX0iT1Va98AVxQ" target="_blank">
                                    <Button
                                        variant="primary_black_alt"
                                        sx={{
                                            width: '100%',
                                        }}
                                    >Kidston on YouTube
                                    </Button>
                                </ExternalLink>
                            </Box>
                        </Box>
                    </Box>
                    <Box
                        bg="black"
                        pl={['sm', 'sm', 'sm', 'sm', 'md']}
                        pr={['sm', 'sm', 'sm', 'sm', 'lg']}
                        py={['sm', 'sm', 'sm', 'sm', '0']}
                        height={['auto', 'auto', 'auto', 'auto', '100%']}
                        width={['100%', '100%', '100%', '100%', '200px', '300px', '492px']}
                        sx={{
                            position: ['inherit', 'inherit', 'inherit', 'inherit', 'absolute'],
                            top: 0,
                            right: 0,
                        }}
                    >
                        {/* Film strip container */}
                        <Box height="100%" sx={{
                            display: ['none', 'none', 'none', 'none', 'block'],
                        }}>
                            <SwiperFilmStrip onPress={switchVideo} options={{
                                direction: 'vertical',
                                spaceBetween: 60,
                                slidesOffsetBefore: 40,
                                slidesOffsetAfter: 40,
                                type: 'films',
                                showTitle: true,
                                mode: 'dark',
                                disableClick: true,
                            }} slides={data} />
                        </Box>
                        <Box sx={{
                            display: ['block', 'block', 'block', 'block', 'none'],
                        }}>
                            <SwiperFilmStrip onPress={switchVideo} options={{
                                direction: 'horizontal',
                                spaceBetween: 0,
                                type: 'films',
                                showTitle: true,
                                mode: 'dark',
                                disableClick: true,
                            }} slides={data} />
                        </Box>
                    </Box>
                </Flex>
            )}
        </>
    )
}

export default GalleryVideo
